import "../../layouts/style.css";
import About from "../about-us/About";
import Contact from "../contact-us/Contact";
import HeroSection from "./components/HeroSection";
import Footer from './../../layouts/Footer';
import TeachingLocations from "../teacherLocations/TeacherLocations";
import PlacementTestSection from "../placementTest/PlacementTestSection";


function HomePage() {
  return (
    <>
      <section className="home_section">
        <div className="hero_background_shape shape_one"></div>
        <div className="hero_background_shape shape_two"></div>

        <div className="container">
          <HeroSection />
        </div>
        {/* <PlacementTestSection /> */}
      <About />
      <TeachingLocations />
      <Contact/>
      <Footer/>
      </section>
    </>
  );
}

export default HomePage;
